import { render, staticRenderFns } from "./BaseSelectOption.vue?vue&type=template&id=1e29626a&scoped=true&"
import script from "./BaseSelectOption.vue?vue&type=script&lang=js&"
export * from "./BaseSelectOption.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectOption.vue?vue&type=style&index=0&id=1e29626a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e29626a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
